import {
  IFormSchemaV2,
  ConditionalRule,
  InputElementUnion,
} from "@graffer-inc/form-schema";
import { ConditionalRuleEditorView } from "@graffer-inc/form-builder";
import { emptyFunction } from "../../../../../utils/function-utils";

export const ConditionalRulesEditors: React.FC<{
  formSchema: IFormSchemaV2;
  editingElement?: InputElementUnion;
  currentRule: ConditionalRule;
  ruleIndex?: number;
}> = ({ formSchema, ruleIndex, currentRule }) => {
  return (
    <>
      <div>
        <div className="level mb-4">
          <div className="level-left">
            <p className="title is-size-5">
              条件分岐設定 # {ruleIndex !== undefined ? ruleIndex + 1 : ""}
            </p>
          </div>
        </div>
      </div>
      <ConditionalRuleEditorView
        formSchema={formSchema}
        ruleIndex={ruleIndex}
        rule={currentRule}
        onUpdate={emptyFunction}
        viewMode="READONLY"
      />
    </>
  );
};
